const DEV = process.env.NODE_ENV !== "production";

export function logWarn(...args) {
  if (DEV) console.warn(...args); // eslint-disable-line no-console
}
